import apiConfig from "./ApiURL.json";
var apiEndpoint = process.env.VUE_APP_TOKO_API || apiConfig.stock;
import App from "./App/App.js";

export default {
  getList(params) {
    let options = { cid: App.Session.getCompanyID() };
    options = Object.assign(options, params);
    const attributes = ["cid", "warehouse", "cashier", "startDate", "endDate"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/salesrecapitulation/list" + urlParams
    };
  },
  getDetails(id, params) {
    let options = {
      cid: App.Session.getCompanyID(),
      id: id,
    };
    options = Object.assign(options, params);
    const attributes = ["cid", "id", "withinvoice"];
    const urlParams = App.Out.getParams(options, attributes);

    return {
      method: App.Enum.Axios.Method.Get,
      url: apiEndpoint + "/api/v1/salesrecapitulation/details" + urlParams
    };
  },
  postSalesRecap(data) {
    return {
      method: App.Enum.Axios.Method.Post,
      url: apiEndpoint + "/api/v1/salesrecapitulation",
      data: data
    };
  },
}